export default __webpack_public_path__ + "static/media/bankTransferArrow.9f16697b.svg";